import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;




async function getusers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getusers",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

export const AutoSquareOffLogServices = {
    
    getusers
}